import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const ChangePinLazy = lazyLoader(
  () => import('./ChangePin' /* webpackChunkName: "change-pin" */),
);

const ChangePinComponent = () => {
  return (
    <Suspense fallback={null}>
      <ChangePinLazy />
    </Suspense>
  );
};

export default ChangePinComponent;
